export default __webpack_public_path__ + "static/media/future_shul.0a996360.jpg";